export enum CalendarMode {
  Month = 'month',
  Year = 'year'
}
